import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=7f2ee2fe&scoped=true"
import script from "./LiveRoom.vue?vue&type=script&lang=js"
export * from "./LiveRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ee2fe",
  null
  
)

export default component.exports